<script>
import { Category } from '@/api'
import fields from '@/components/fields/'
import FormMixin from '@/crudBases/form/FormMixin'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Category List' }
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Nazwa',
          required: true,
          modelPath: [this, 'form', 'name'],
          type: 'textarea',
          multilingual: true
        })
      ]
    }
  },
  computed: {
    service() {
      return Category
    }
  }
}
</script>
